/**
 * @file index.js
 * @author imcuttle <moyuyc95@gmail.com>
 * @date 2018/11/7
 *
 */

module.exports = require('./lib')
